import { render } from "./CargoesView.vue?vue&type=template&id=2a1be0b6&scoped=true"
import script from "./CargoesView.vue?vue&type=script&lang=js"
export * from "./CargoesView.vue?vue&type=script&lang=js"

import "./CargoesView.vue?vue&type=style&index=0&id=2a1be0b6&scoped=true&lang=css"
import "./CargoesView.vue?vue&type=style&index=1&id=2a1be0b6&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1be0b6"]])

export default __exports__